import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useGameConfigCalamity } from '../../../store';

const Calamity = ({
  selectedRound,
  noOfCalamities,
  calamities,
  calamityLevels,
  exhaustLand,
  setNoOfCalamities,
  setCalamities,
  setCalamityLevels,
  setExhaustLand,
}) => {
  const [exhaustLandChecked, setExhaustLandChecked] = useState(false);

  const addCalamities = () => {
    setCalamities((oldArray) => [...oldArray, 'Earthquake']);
    setCalamityLevels((oldArray) => [...oldArray, 'Level1']);
  };

  const updateValue = (i, value, target) => {
    if (target === 'calamity') {
      const tempCalamity = [...calamities];
      tempCalamity[i] = value;
      setCalamities(tempCalamity);
    }

    if (target === 'level') {
      const tempCalamityLevel = [...calamityLevels];
      tempCalamityLevel[i] = value;
      setCalamityLevels(tempCalamityLevel);
    }
  };

  const deleteCalamity = (i) => {
    const tempCalamity = [...calamities];
    tempCalamity.splice(i, 1);
    setCalamities(tempCalamity);

    const tempCalamityLevel = [...calamityLevels];
    tempCalamityLevel.splice(i, 1);
    setCalamityLevels(tempCalamityLevel);
  };

  const calamity = (item, i) => {
    let currentCalamity = item.replace(/[-+()[\]""]/g, '');
    let currentCalamityLevel = calamityLevels[i].replace(/[-+()[\]""]/g, '');

    currentCalamity = currentCalamity.trim();
    currentCalamityLevel = currentCalamityLevel.trim();

    return (
      <div className="form-row mt-3 align-items-end" key={i}>
        <div className="col-md-2">
          <h5>
            Calamity
            {i + 1}
          </h5>
        </div>
        <div className="col-md">
          <label htmlFor="temp-id">Name </label>
          <select
            className="form-control"
            name="calamities"
            placeholder="calamitie name"
            onChange={(e) => updateValue(i, e.target.value, 'calamity')}
            data-index={i}
            value={currentCalamity}>
            <option value="Earthquake">Earthquake</option>
            <option value="Volcanic Eruption">Volcanic Eruption</option>
            <option value="Acid Rain">Acid Rain</option>
            <option value="Acid Storm">Acid Storm</option>
            <option value="Forest Fire">Forest Fire</option>
          </select>
        </div>
        <div className="col-md">
          <label htmlFor="temp-id">Level </label>
          <select
            className="form-control"
            onChange={(e) => updateValue(i, e.target.value, 'level')}
            name="calamities_lvl"
            data-index={i}
            value={currentCalamityLevel}>
            <option value="Level1">Level 1</option>
            <option value="Level2">Level 2</option>
            <option value="Level3">Level 3</option>
          </select>
        </div>
        <div className="col-md-1">
          <button
            type="button"
            onClick={() => deleteCalamity(i)}
            className="btn btn-primary mt-2 px-4">
            Delete
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="calamity">
      <h1>Edit Calamity</h1>
      <form className="p-4">
        <div className="form-row">
          <div className="col-md">
            {/* <label htmlFor="temp-id">
              No. Of Calamities
              {noOfCalamities}
            </label> */}
            {/* <input
              type="number"
              className="form-control"
              name="no_calamities"
              placeholder="No. Of Calamities"
              value={noOfCalamities}
              setNoOfCalamities
              onChange={(e) => {
                setNoOfCalamities(e.target.value);
              }}
            /> */}
          </div>
        </div>
        {calamities ? calamities.map((item, i) => calamity(item, i)) : null}
        <div className="text-center">
          <span className="p-4">Add Calamities: </span>
          <button type="button" className="btn btn-secondary mt-3 px-5" onClick={addCalamities}>
            +
          </button>
        </div>

        <div className="custom-control custom-checkbox mt-4 mb-2">
          <input
            type="checkbox"
            className="custom-control-input"
            id="days_check"
            name="days_check"
            checked={exhaustLandChecked}
            onClick={(e) => {
              setExhaustLandChecked(e.target.checked);
              setExhaustLand(null);
            }}
          />
          <label className="custom-control-label" htmlFor="days_check">
            Exhaust Land
          </label>
        </div>
        <div
          className={
            exhaustLandChecked ? 'form-row align-items-end ' : 'form-row align-items-end d-none'
          }>
          <label htmlFor="temp-id" className="col-md-4 p-0">
            No. of Harvest before tile exhaust :
          </label>
          <input
            type="number"
            className="form-control col-md"
            placeholder="No. of harvest"
            name="exhaust_land"
            value={exhaustLand}
            onChange={(e) => setExhaustLand(e.target.value)}
          />
          <div className="col-md" />
        </div>
      </form>
    </div>
  );
};

Calamity.propTypes = {
  selectedRound: PropTypes.number,
  noOfCalamities: PropTypes.number,
  calamities: PropTypes.number,
  calamityLevels: PropTypes.number,
  exhaustLand: PropTypes.number,

  setNoOfCalamities: PropTypes.func,
  setCalamities: PropTypes.func,
  setCalamityLevels: PropTypes.func,
  setExhaustLand: PropTypes.func,
};

Calamity.defaultProps = {
  selectedRound: '',
  noOfCalamities: '',
  calamities: '',
  calamityLevels: '',
  exhaustLand: '',
  setNoOfCalamities: '',
  setCalamities: '',
  setCalamityLevels: '',
  setExhaustLand: '',
};

export default Calamity;
